import { lists } from '@/api'

const getSections = (context, id) => {
  return new Promise((resolve, reject) => {
    lists.fetchOne(id).then(response => {
      context.commit('SECTIONS_UPDATED', response.data._sections.map(section => {
        section.selected = () => {
          return section._players.filter(player => {
            return player.selected
          })
        }
        section.playerState = (id, state = false) => {
          section._players.map((player, key) => {
            if (key === id) {
              if (state === -1) {
                player.selected = !player.selected
              } else {
                player.selected = state
              }
            }
            return player
          })
        }
        section._players = section._players.map(player => {
          player.selected = 0
          return player
        })
        return section
      }))
      context.commit('TITLE_UPDATED', response.data.name)
      resolve(response)
    })
  })
}

const saveList = (context, list) => {
  return new Promise((resolve, reject) => {
    lists.create(list).then(response => {
      resolve(response)
    })
  })
}

const getSettings = (context, id) => {
  return new Promise((resolve, reject) => {
    lists.fetchSettings(id).then(({ data }) => {
      context.commit('SETTINGS_UPDATED', data)
      resolve()
    })
  })
}

export default {
  getSections,
  saveList,
  getSettings
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions.js